import { LearningItem } from "./types";

export const letters: LearningItem[] = [
  {
    id: "A",
    label: "A",
    word: "Apple",
    model: "/models/apple.glb",
    audio: "/audio/a_apple.mp3",
    phonics: "a",
    color: "#ef4444", // red
    category: "alphabet",
  },
  {
    id: "B",
    label: "B",
    word: "Ball",
    model: "/models/ball.glb",
    audio: "/audio/b_ball.mp3",
    phonics: "b",
    color: "#3b82f6", // blue
    category: "alphabet",
  },
  {
    id: "C",
    label: "C",
    word: "Cat",
    model: "/models/cat.glb",
    audio: "/audio/c_cat.mp3",
    phonics: "c",
    color: "#10b981", // green
    category: "alphabet",
  },
  {
    id: "D",
    label: "D",
    word: "Dog",
    model: "/models/dog.glb",
    audio: "/audio/d_dog.mp3",
    phonics: "d",
    color: "#f59e0b", // amber
    category: "alphabet",
  },
  {
    id: "E",
    label: "E",
    word: "Elephant",
    model: "/models/elephant.glb",
    audio: "/audio/e_elephant.mp3",
    phonics: "e",
    color: "#8b5cf6", // purple
    category: "alphabet",
  },
  {
    id: "F",
    label: "F",
    word: "Fish",
    model: "/models/fish.glb",
    audio: "/audio/f_fish.mp3",
    phonics: "f",
    color: "#06b6d4", // cyan
    category: "alphabet",
  },
  {
    id: "G",
    label: "G",
    word: "Giraffe",
    model: "/models/giraffe.glb",
    audio: "/audio/g_giraffe.mp3",
    phonics: "g",
    color: "#f97316", // orange
    category: "alphabet",
  },
  {
    id: "H",
    label: "H",
    word: "House",
    model: "/models/house.glb",
    audio: "/audio/h_house.mp3",
    phonics: "h",
    color: "#84cc16", // lime
    category: "alphabet",
  },
  {
    id: "I",
    label: "I",
    word: "Ice",
    model: "/models/ice.glb",
    audio: "/audio/i_ice.mp3",
    phonics: "i",
    color: "#06b6d4", // cyan
    category: "alphabet",
  },
  {
    id: "J",
    label: "J",
    word: "Jellyfish",
    model: "/models/jellyfish.glb",
    audio: "/audio/j_jellyfish.mp3",
    phonics: "j",
    color: "#a855f7", // purple
    category: "alphabet",
  },
  {
    id: "K",
    label: "K",
    word: "Kite",
    model: "/models/kite.glb",
    audio: "/audio/k_kite.mp3",
    phonics: "k",
    color: "#ec4899", // pink
    category: "alphabet",
  },
  {
    id: "L",
    label: "L",
    word: "Lion",
    model: "/models/lion.glb",
    audio: "/audio/l_lion.mp3",
    phonics: "l",
    color: "#f59e0b", // amber
    category: "alphabet",
  },
  {
    id: "M",
    label: "M",
    word: "Monkey",
    model: "/models/monkey.glb",
    audio: "/audio/m_monkey.mp3",
    phonics: "m",
    color: "#10b981", // green
    category: "alphabet",
  },
  {
    id: "N",
    label: "N",
    word: "Nest",
    model: "/models/nest.glb",
    audio: "/audio/n_nest.mp3",
    phonics: "n",
    color: "#3b82f6", // blue
    category: "alphabet",
  },
  {
    id: "O",
    label: "O",
    word: "Octopus",
    model: "/models/octopus.glb",
    audio: "/audio/o_octopus.mp3",
    phonics: "o",
    color: "#ef4444", // red
    category: "alphabet",
  },
  {
    id: "P",
    label: "P",
    word: "Penguin",
    model: "/models/penguin.glb",
    audio: "/audio/p_penguin.mp3",
    phonics: "p",
    color: "#6366f1", // indigo
    category: "alphabet",
  },
  {
    id: "Q",
    label: "Q",
    word: "Queen",
    model: "/models/queen.glb",
    audio: "/audio/q_queen.mp3",
    phonics: "q",
    color: "#8b5cf6", // purple
    category: "alphabet",
  },
  {
    id: "R",
    label: "R",
    word: "Rabbit",
    model: "/models/rabbit.glb",
    audio: "/audio/r_rabbit.mp3",
    phonics: "r",
    color: "#f97316", // orange
    category: "alphabet",
  },
  {
    id: "S",
    label: "S",
    word: "Sun",
    model: "/models/sun.glb",
    audio: "/audio/s_sun.mp3",
    phonics: "s",
    color: "#fbbf24", // yellow
    category: "alphabet",
  },
  {
    id: "T",
    label: "T",
    word: "Tiger",
    model: "/models/tiger.glb",
    audio: "/audio/t_tiger.mp3",
    phonics: "t",
    color: "#ef4444", // red
    category: "alphabet",
  },
  {
    id: "U",
    label: "U",
    word: "Umbrella",
    model: "/models/umbrella.glb",
    audio: "/audio/u_umbrella.mp3",
    phonics: "u",
    color: "#3b82f6", // blue
    category: "alphabet",
  },
  {
    id: "V",
    label: "V",
    word: "Violin",
    model: "/models/violin.glb",
    audio: "/audio/v_violin.mp3",
    phonics: "v",
    color: "#10b981", // green
    category: "alphabet",
  },
  {
    id: "W",
    label: "W",
    word: "Whale",
    model: "/models/whale.glb",
    audio: "/audio/w_whale.mp3",
    phonics: "w",
    color: "#06b6d4", // cyan
    category: "alphabet",
  },
  {
    id: "X",
    label: "X",
    word: "Xylophone",
    model: "/models/xylophone.glb",
    audio: "/audio/x_xylophone.mp3",
    phonics: "x",
    color: "#8b5cf6", // purple
    category: "alphabet",
  },
  {
    id: "Y",
    label: "Y",
    word: "Yacht",
    model: "/models/yacht.glb",
    audio: "/audio/y_yacht.mp3",
    phonics: "y",
    color: "#f59e0b", // amber
    category: "alphabet",
  },
  {
    id: "Z",
    label: "Z",
    word: "Zebra",
    model: "/models/zebra.glb",
    audio: "/audio/z_zebra.mp3",
    phonics: "z",
    color: "#6366f1", // indigo
    category: "alphabet",
  },
];

